import { APP_DICTIONARY } from '@/common/messages/root';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const LanguageMenu = defineMessages({
  title: {
    id: 'app.components.LanguageMenu.title',
  },
  cs: {
    id: 'app.components.LanguageMenu.cs',
  },
  sk: {
    id: 'app.components.LanguageMenu.sk',
  },
  en: {
    id: 'app.components.LanguageMenu.en',
  },
});

export const CounterValue = defineMessages({
  lastCounterTime: {
    id: 'app.components.CounterValue.lastCounterTime',
  },
});

export const Table = defineMessages({
  total: APP_DICTIONARY.total,
});

export const BuildingFloor = defineMessages({
  undergroundFloorLabel: {
    id: 'app.routes.meters.routes.detail.BuildingFloorSelect.undergroundFloor',
  },
  groundFloor: { id: 'app.routes.meters.routes.detail.BuildingFloorSelect.groundFloor' },
  floorLabel: { id: 'app.routes.meters.routes.detail.BuildingFloorSelect.floor' },
});
